import alt from '../alt';
import ZopimActions from './zopim_actions';

class ZopimStore {
  constructor() {
    this.chatOnline = false;

    this.bindListeners({
      handleOnlineStatusUpdated: ZopimActions.ONLINE_STATUS_UPDATED,
    });
  }

  handleOnlineStatusUpdated(status) {
    this.chatOnline = status;
  }
}

export default alt.createStore(ZopimStore, 'ZopimStore');



// WEBPACK FOOTER //
// ./javascripts/components/zopim/zopim_store.js